import FormSelectFieldDark from "@/components/UI/FormSelectFieldDark/FormSelectFieldDark";
import { ArrowDownIcon } from "@/icons";

export default function SelectMicrophone(props) {
  const { control, microphones, disabled } = props;

  return (
    <FormSelectFieldDark
      name="microphone"
      control={control}
      label="Microphone"
      size="medium"
      disabled={disabled}
      options={microphones}
      IconComponent={ArrowDownIcon}
      defaultValue={microphones[0]}
    />
  );
}
